import { render, staticRenderFns } from "./ToggleFavoriteFolder.vue?vue&type=template&id=fe3622f6&"
import script from "./ToggleFavoriteFolder.vue?vue&type=script&lang=js&"
export * from "./ToggleFavoriteFolder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports